// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__SyKRi","logo":"MainNavigation_logo__kAKbX","nav":"MainNavigation_nav__zjU-j","active":"MainNavigation_active__IX9gp"};